import { createFileRoute } from '@tanstack/react-router';
import { TrackerImportPage } from '../../../features/imports/tracker-import-page.tsx';
import { guardPermission } from '../../../shell/guard.ts';

// Go-live tracker import (T36 screen, spec §5.10, Q36). Owner only (import.tracker).
export const Route = createFileRoute('/_authed/admin/imports')({
  beforeLoad: guardPermission('import.tracker'),
  component: TrackerImportPage,
});
